import React from "react";

export const NoteIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_441_24876)">
<path d="M2.92766 2.92766C4.8781 0.97522 7.23621 0 10 0C12.7638 0 15.1199 0.97522 17.0723 2.92766C19.0248 4.8801 20 7.22822 20 9.97602C20 12.7238 19.0248 15.0739 17.0723 17.0264C15.1199 18.9788 12.7638 19.952 10 19.952C7.23621 19.952 4.8781 18.9768 2.92766 17.0264C0.977218 15.0759 0 12.7238 0 9.97602C0 7.22822 0.97522 4.8781 2.92766 2.92766ZM4.35651 15.6435C5.91727 17.2042 7.79776 17.9856 10 17.9856C12.2022 17.9856 14.0827 17.2042 15.6435 15.6435C17.2042 14.0827 17.9856 12.1942 17.9856 9.97602C17.9856 7.75779 17.2042 5.8713 15.6435 4.30855C14.0827 2.7458 12.2002 1.96643 10 1.96643C7.79976 1.96643 5.91727 2.7478 4.35651 4.30855C2.79576 5.8693 2.01439 7.75979 2.01439 9.97602C2.01439 12.1922 2.79377 14.0827 4.35651 15.6435ZM8.99281 6.97842V4.96403H11.0072V6.97842H8.99281ZM8.99281 14.988V8.99281H11.0072V14.988H8.99281Z" fill="url(#paint0_linear_441_24876)"/>
</g>
<defs>
<linearGradient id="paint0_linear_441_24876" x1="0" y1="9.9767" x2="20.001" y2="9.9767" gradientUnits="userSpaceOnUse">
<stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
</linearGradient>
<clipPath id="clip0_441_24876">
<rect width="20" height="19.952" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};
